import React from "react";
import { AutoComplete } from "antd";
export default ({
  value,
  field,
  options = [],
  onChange,
  placeholder,
  opts = {}
}) => (
  <AutoComplete
    name={field}
    dataSource={(options || []).map(d => d.name)}
    value={value || undefined}
    onChange={onChange}
    placeholder={placeholder || "请输入"}
    {...opts}
  />
);
